<template>
  <div>
    <el-button size="mini"
               type="success"
               @click="onReReviewPassed()">复审通过
    </el-button>
    <el-button size="mini"
               type="danger"
               @click="onReReviewNotPassed()">复审不通过
    </el-button>
  </div>
</template>

<script>
import ReviewBox from '@views/question-review/components/ReviewBox/index'

export default {
  components: {},
  mixins: [],
  props: {
    salary: [Number, String],
    components: Object,
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  beforeCreate () {},
  created () {},
  mounted () {},
  methods: {
    /**
     * 复审通过方法
     */
    onReReviewPassed () {
      // 审核通过结算确认
      ReviewBox.orderReConfirm({
        title: '订单复审通过',
        components: this.components,
        callback: (data) => {
          this.$emit('pass', data)
        },
      }, this.salary)
    },
    /**
     * 复审不通过方法
     */
    onReReviewNotPassed () {
      // 审核不通过结算确认
      ReviewBox.orderReBack({
        title: '订单复审不通过',
        components: this.components,
        callback: (data) => {
          this.$emit('not-pass', data)
        },
      })
    },
  },
}
</script>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>



// WEBPACK FOOTER //
// src/views/order-review/components/OrderRereviewButton.vue